import {
  ValidationProvider,
  ValidationObserver,
  extend,
  configure
} from "vee-validate";
import {
  required,
  required_if,
  confirmed,
  oneOf,
  size,
  max,
  regex
} from "vee-validate/dist/rules";
import i18n from "./i18n/index.js";

configure({
  // Установка способа отображения сообщений у всех Validation Rule
  defaultMessage: (_, values) => i18n.t(`Validations.${values._rule_}`, values)
});

extend("required", required);
extend("required_if", required_if);
extend("confirmed", confirmed);
extend("oneOf", oneOf);
extend("size", size);
extend("max", max);
extend("regex", regex);
extend("is_integer", {
  validate: value => new RegExp(/^0$|^([1-9]\d*)$/).test(value)
});
extend("email", {
  validate: value => {
    const regex = new RegExp(
      // eslint-disable-next-line no-control-regex
      /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
    );
    return regex.test(value);
  }
});
extend("phone", {
  validate: value => {
    const regex = new RegExp(/^\+?[\d\s()-]+$/);
    return regex.test(value);
  }
});
extend("regex_slug", {
  validate: value => {
    const regex = new RegExp(/^[.a-z0-9_-]+$/);
    return regex.test(value);
  }
});
extend("time", {
  validate: value => {
    const regex = new RegExp(/^(\d\d):(\d\d)$|^$/);
    const match = String(value).match(regex);
    if (!match) return false;
    const hour = parseInt(match[1]);
    if (isNaN(hour) || hour < 0 || hour > 23) return false;
    const minute = parseInt(match[2]);
    return !(isNaN(minute) || minute < 0 || minute > 59);
  }
});
extend("strong_password", {
  validate: value => {
    const strongRegex = new RegExp(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])(?=.{8,})/
    );
    return strongRegex.test(value);
  }
});

export { ValidationProvider, ValidationObserver };
